import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import GraphicEqIcon from '@mui/icons-material/GraphicEq'
import ResultButton from './ResultButton'

/**
 * Analysis-list entry point for a tumour RNA analysis: fusions, splice variants,
 * expression and the library QC. Keyed on the analysis wrapper, like the
 * somatic variants button, and the row's main result. On a DNA row it opens
 * the paired RNA, with `title` naming that RNA sample on hover.
 */
const DEFAULT_TITLE = 'Fusions, splice variants and expression of this tumour RNA'

const GoToRnaAnalysis = ({ analysisWrapperId, title, testId }) => {
  const url = `/libra/rna/${analysisWrapperId}`

  const handleClick = (e) => {
    // Left click only, so middle-click still opens a new tab.
    if (e.button === 0) {
      e.preventDefault()
      window.location.href = url
    }
  }

  return (
    <Tooltip title={title || DEFAULT_TITLE} arrow>
      <ResultButton
        primary
        tone="somatic"
        startIcon={<GraphicEqIcon />}
        href={url}
        onClick={handleClick}
        data-testid={testId}
      >
        RNA
      </ResultButton>
    </Tooltip>
  )
}

GoToRnaAnalysis.propTypes = {
  analysisWrapperId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string,
  testId: PropTypes.string,
}

GoToRnaAnalysis.defaultProps = {
  title: null,
  testId: 'go-to-rna',
}

export default GoToRnaAnalysis
